module.exports = __webpack_public_path__ + "img/ic_recognition.f62b6070.png";